import {
    GETUSERWITHDRAWLIMITLIST_SUCCESS,
    GETUSERWITHDRAWLIMITLIST_FAILED,
    RESET_GETUSERWITHDRAWLIMITLIST,
    LOADING_GETUSERWITHDRAWLIMITLIST,
    NETWORK_ERROR_GETUSERWITHDRAWLIMITLIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETUSERWITHDRAWLIMITLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETUSERWITHDRAWLIMITLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETUSERWITHDRAWLIMITLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETUSERWITHDRAWLIMITLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETUSERWITHDRAWLIMITLIST:
            return (state = initialState);
        default:
            return state;
    }
};
